export default {
    root: ({props, context, parent}) => ({
        class: [
            // Font
            "leading-[normal]",
            "placeholder:font-normal",

            // Flex
            {"flex-1 w-[1%]": parent.instance.$name == "InputGroup"},

            // Spacing
            "m-0",
            {"w-full": props.fluid},

            // Size
            {
                "px-4 py-4": props.size == "large",
                "px-2 py-2": props.size == "small",
                "p-3": props.size == null,
            },

            // Shape
            {"rounded-md": parent.instance.$name !== "InputGroup"},
            {"first:rounded-l-md rounded-none last:rounded-r-md": parent.instance.$name == "InputGroup"},
            {"border-0 border-y border-l last:border-r": parent.instance.$name == "InputGroup"},
            {"first:ml-0 -ml-px": parent.instance.$name == "InputGroup" && !props.showButtons},

            // Colors
            "text-stone-600 dark:text-stone-200",
            "placeholder:text-stone-400 dark:placeholder:text-stone-500",
            "bg-stone-50 dark:bg-stone-900",
            "border",
            {"border-stone-300 dark:border-stone-600": !props.invalid},

            // Invalid State
            {"border-red-500 dark:border-red-400": props.invalid},

            // States
            {
                "hover:border-askr-green": !context.disabled && !props.invalid,
                "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-500/50 dark:focus:ring-askr-green-400/50 focus:z-10":
                    !context.disabled,
                "opacity-60 select-none pointer-events-none cursor-default": context.disabled,
            },

            // Filled State *for FloatLabel
            {
                filled:
                    (parent.instance?.$name == "FloatLabel" && context.filled) ||
                    (parent.instance?.$parentInstance?.$name == "FloatLabel" &&
                        parent.props.modelValue !== null &&
                        parent.props.modelValue?.length !== 0),
            },

            // Misc
            "appearance-none",
            "transition-colors duration-200",
        ],
    }),
};
